import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import routes from './config/settings/routes'
import ScrollToTop from './components/Navigation/ScrollToTop'
import AboutDataGoalPage from './pages/AboutDataGoal'
import AboutDefinitionsPage from './pages/AboutDefinitions'
import AboutSiteGoalPage from './pages/AboutSiteGoal'
import AboutSuggestDataPage from './pages/AboutSuggestData'
import AboutVideoTutorialsPage from './pages/AboutVideoTutorials'
import BuyerPage from './pages/Buyer'
import BuyersPage from './pages/Buyers'
import ComparatorPage from './pages/Comparator'
import ContingenciesPage from './pages/Contingencies'
import DownloadAddonsPage from './pages/DownloadAddons'
import DownloadDevelopmentToolsPage from './pages/DownloadDevelopmentTools'
import DownloadFrameworkPage from './pages/DownloadFramework'
import DownloadOCDSPage from './pages/DownloadOCDS'
import DownloadOrdersAndBiddingsPage from './pages/DownloadOrdersAndBiddings'
import DownloadAgilePurchasePage from './pages/DownloadAgilePurchase'
import DownloadLargePurchaseProcessesPage from './pages/DownloadLargePurchaseProcessesPage'
import DownloadPurchasePlanPage from './pages/DownloadPurchasePlanPage'
import DownloadContractsPage from './pages/DownloadContracts'
import HomePage from './pages/Home'
import NotFoundPage from './pages/NotFound'
import ProviderPage from './pages/Provider'
import ProvidersPage from './pages/Providers'
import RegionalInfoPage from './pages/RegionalInfo'
import SectorPage from './pages/Sector'
import AgilePurchase from './pages/AgilePurchase'
import SmallerCompanies from './pages/SmallerCompanies'
import DownloadCfmpPage from './pages/DownloadCfmp'

/**
 * The Routing's component.
 */
const Routing = () => (
  <BrowserRouter>
    <ScrollToTop>
      <Routes>
        <Route caseSensitive element={<HomePage />} path={routes.root} />
        <Route caseSensitive element={<AboutDataGoalPage />} path={routes.aboutDataGoal} />
        <Route caseSensitive element={<AboutDefinitionsPage />} path={routes.aboutDefinitions} />
        <Route caseSensitive element={<AboutSiteGoalPage />} path={routes.about} />
        <Route caseSensitive element={<AboutSiteGoalPage />} path={routes.aboutSiteGoal} />
        <Route caseSensitive element={<AboutSuggestDataPage />} path={routes.aboutSuggestData} />
        <Route caseSensitive element={<AboutVideoTutorialsPage />} path={routes.aboutVideoTutorials} />
        <Route caseSensitive element={<BuyerPage />} path={routes.organization} />
        <Route caseSensitive element={<BuyersPage />} path={routes.organizations} />
        <Route caseSensitive element={<ComparatorPage />} path={routes.comparator} />
        <Route caseSensitive element={<ContingenciesPage />} path={routes.contingencies} />
        <Route caseSensitive element={<DownloadAddonsPage />} path={routes.downloadAddons} />
        <Route caseSensitive element={<DownloadDevelopmentToolsPage />} path={routes.downloadDevelopmentTools} />
        <Route caseSensitive element={<DownloadFrameworkPage />} path={routes.downloadFramework} />
        <Route caseSensitive element={<DownloadOCDSPage />} path={routes.downloadOCDS} />
        <Route caseSensitive element={<DownloadOrdersAndBiddingsPage />} path={routes.downloads} />
        <Route caseSensitive element={<DownloadOrdersAndBiddingsPage />} path={routes.downloadOrderAndBiddings} />
        <Route caseSensitive element={<DownloadAgilePurchasePage />} path={routes.downloadAgilePurchase} />
        <Route
          caseSensitive
          element={<DownloadLargePurchaseProcessesPage />}
          path={routes.downloadLargePurchaseProcesses}
        />
        <Route caseSensitive element={<DownloadPurchasePlanPage />} path={routes.downloadPurchasePlan} />
        <Route caseSensitive element={<DownloadContractsPage />} path={routes.downloadContracts} />
        <Route caseSensitive element={<DownloadCfmpPage />} path={routes.downloadCfmp} />
        <Route caseSensitive element={<ProviderPage />} path={routes.provider} />
        <Route caseSensitive element={<ProvidersPage />} path={routes.providers} />
        <Route caseSensitive element={<RegionalInfoPage />} path={routes.regionalInfo} />
        <Route caseSensitive element={<SectorPage />} path={routes.sector} />
        <Route caseSensitive element={<AgilePurchase />} path={routes.agilePurchase} />
        <Route caseSensitive element={<SmallerCompanies />} path={routes.smallerCompanies} />
        <Route element={<NotFoundPage />} path="*" />
      </Routes>
    </ScrollToTop>
  </BrowserRouter>
)

export default Routing
